import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  site: {
    logo: {
      src: { light: "/logo-light.png", dark: "/logo-dark.png" },
      alt: "Easyway",
      width: "120px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            "/notification",
            "/sftp",
            // {
            //   type: "link",
            //   icon: "folder-cog",
            //   badge: {
            //     label: "New",
            //     color: "purple",
            //   },
            //   label: "API Reference",
            //   to: "/api",
            // },
          ],
        },
        {
          type: "category",
          label: "Appendix",
          // collapsible: false,
          icon: "link",
          items: [
            "/appendix-1"
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/apiv3.json",
      path: "/api",
      options: {
        disablePlayground: true
      }
    }
  ],
};

export default config;
